<template>
  <div class="padding-md">
    <el-row>
      <el-col :span="24">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="应用名称">
            <el-input v-model="searchForm.name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" native-type="submit" @click.native.prevent="loadData">查询</el-button>
            <el-button type="success" @click="showDialog(false)">添加</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="24">
        <el-table :data="games" :stripe="true" v-loading="loading" border style="width: 100%">
          <el-table-column prop="id" width="80" label="ID"></el-table-column>
          <el-table-column prop="name" label="游戏名称"></el-table-column>
          <el-table-column prop="iconName" label="图标名称"></el-table-column>
          <el-table-column prop="appKey" label="游戏标识"></el-table-column>
          <el-table-column prop="appSecret" label="游戏签名"></el-table-column>
          <el-table-column prop="redirectUrl" label="转发地址"></el-table-column>
          <el-table-column prop="noticeUrl" label="通知地址"></el-table-column>
          <el-table-column prop="viewStatus" label="横竖屏"></el-table-column>
          <el-table-column fixed="right" label="操作" min-width="160" width="200">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="showDialog(scope.row)">修改</el-button>
              <el-button type="danger" size="mini" @click="deleteGame(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-dialog el-dialog :title="title" :visible.sync="showEditorDialog" class="update"
               :before-close="handleBeforeCloseDialog">
      <el-form :model="formData" ref="formData" label-width="80px" :rules="formRules">
        <!--<el-form-item label="游戏图标">-->
        <!--<el-upload drag class="el-upload__demo" :action="action" :headers="headers" :show-file-list="false"-->
        <!--:on-success="handleAvatarSuccess"-->
        <!--:before-upload="beforeAvatarUpload">-->
        <!--<div class="img-box">-->
        <!--<img v-if="formData.iconUrl" :src="formData.iconUrl" class="avatar" alt="icon">-->
        <!--<i class="el-icon-plus avatar-uploader-icon" v-else></i>-->
        <!--</div>-->
        <!--</el-upload>-->
        <!--</el-form-item>-->
        <el-form-item label="图标名称" prop="iconName" class="form-item__full-width" placeholder="请输入游戏名称">
          <el-input v-model="formData.iconName"></el-input>
        </el-form-item>
        <el-form-item prop="name" class="form-item__full-width" label="游戏名称" placeholder="请输入游戏名称">
          <el-input type="text" v-model.trim="formData.name"></el-input>
        </el-form-item>
        <el-form-item prop="appKey" class="form-item__full-width" label="游戏标识" placeholder="请输入游戏标识">
          <el-input type="text" v-model.trim="formData.appKey" :disabled="!!formData.id"></el-input>
        </el-form-item>
        <!--<el-form-item prop="appSecret" class="form-item__full-width" label="游戏签名" placeholder="请输入游戏签名">-->
        <!--<el-input type="text" v-model.trim="formData.appSecret"></el-input>-->
        <!--</el-form-item>-->
        <el-form-item prop="redirectUrl" class="form-item__full-width" label="转发地址" placeholder="请输入游戏转发地址">
          <el-input type="text" v-model.trim="formData.redirectUrl"></el-input>
        </el-form-item>
        <el-form-item prop="noticeUrl" class="form-item__full-width" label="通知地址" placeholder="请输入游戏通知地址">
          <el-input type="text" v-model.trim="formData.noticeUrl"></el-input>
        </el-form-item>
        <el-form-item prop="viewStatus" class="form-item__full-width" label="横竖屏" placeholder="请输入横竖屏">
          <el-input type="text" v-model.trim="formData.viewStatus"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" native-type="submit" @click.native.prevent="handleSubmit('formData')">保存</el-button>
          <el-button @click="closeDialog">返回</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>

  import {
    getGames,
    saveGame,
    updateGame,
    deleteGame
  } from '@/api/games';
  // import { getToken } from '@/utils/auth';
  // import configs from '@/configs';

  function defaultForm() {
    return {
      name: null,
      appKey: null,
      appSecret: null,
      iconUrl: null,
      redirectUrl: null,
      noticeUrl: null,
      viewStatus: 0
    }
  }

  export default {
    name: 'games',
    data() {
      return {
        // action: `${configs.API_SERVER}/api/admin/upload/icon`,
        // headers: {
        //   'X-Access-Token': getToken()
        // },
        loading: true,
        games: [],
        title: '',
        showEditorDialog: false,
        formData: defaultForm(),
        searchForm: {
          name: null
        },
        formRules: {
          name: [{required: true, trigger: 'blur', message: '请输入游戏名称'}],
          iconName: [{required: true, trigger: 'blur', message: '请输入游戏名称'}],
          appKey: [{required: true, trigger: 'blur', message: '请输入游戏标识'}],
          redirectUrl: [{required: true, trigger: 'blur', message: '请输入游戏转发地址'}],
          noticeUrl: [{required: true, trigger: 'blur', message: '请输入应用通知地址'}],
          viewStatus: [{required: true, trigger: 'blur', message: '请输入横竖屏标识'}]
        }
      };
    },
    /**
     * 初始化钩子
     */
    created() {
      this.loadData();
    },
    methods: {
      /**
       *根据条件查询
       */
      loadData() {
        this.loading = true;
        getGames({
          ...this.searchForm
        }).then(result => {
          this.loading = false;
          this.games = result;
        }).catch(() => {
          this.loading = false;
        });
      },

      /**
       * 打开编辑面板
       */
      showDialog(obj) {
        this.showEditorDialog = true;
        if (!obj) {
          this.title = '添加H5游戏';
          this.formData = defaultForm();
        } else {
          this.title = '修改H5游戏信息';
          this.formData = {
            ...obj
          };
        }

      },
      /**
       * 关闭面板
       */
      closeDialog() {
        this.clearForm();
        this.showEditorDialog = false;
      },
      clearForm() {
        this.$refs['formData'].resetFields();
      },

      handleBeforeCloseDialog(done) {
        this.clearForm();
        done();
      },

      /**
       * 提交前验证
       */
      handleSubmit(name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            this.saveGame();
          } else {
            this.$message.error('提交失败');
            return false;
          }
        });
      },
      /**
       * 保存应用
       */
      saveGame() {
        const loading = this.$loading();
        if (this.formData.id) {
          updateGame(this.formData).then(result => {
            this.showEditorDialog = !this.showEditorDialog;
            loading.close();
            if (result) {
              this.$message({
                message: '修改成功',
                type: 'success'
              });
              this.loadData();
            }
          }).catch(() => loading.close());
        } else {
          saveGame(this.formData).then(() => {
            this.showEditorDialog = !this.showEditorDialog;
            loading.close();
            this.$message({
              message: '添加成功',
              type: 'success'
            });
            this.loadData();
          }).catch(() => loading.close());
        }
      },
      /**
       * 删除
       */
      deleteGame(obj) {
        this.$confirm('确认删除该应用吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const loading = this.$loading();
          deleteGame(obj.id).then(result => {
            loading.close();
            if (result > 0) {
              this.$message({
                message: '删除成功',
                type: 'success'
              });
              this.loadData();
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      /**
       * 上传成功后显示图片
       * @param res 响应
       */
      handleAvatarSuccess(res) {
        this.formData.iconUrl = res.file.url;
      },

      /**
       * 图片上传之前验证格式,大小
       */
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg' || 'image/jpg' || 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      }
    }
  };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .update {
    margin-top: 10px;

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 100px;
      height: 100px;
      line-height: 100px;
      text-align: center;
    }

    .avatar {
      width: 100%;
      height: 100%;
      display: block;
    }

    .img-box {
      width: 100px;
      height: 100px;
    }

    .number-input {
      width: 195px;
    }

    .form-item__full-width .el-select,
    .form-item__full-width .el-input-number {
      width: 100%;
    }

  }
</style>





// WEBPACK FOOTER //
// games.vue?24215a26